import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=f37b6b82"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"

import "./TwoFactorChallenge.vue?vue&type=style&index=0&id=f37b6b82&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__